import { useMemo } from 'react';

import { EditTableColumns } from '../types';

export const useEditTableAllCells = <T>(columns: EditTableColumns<T>[]) => {
  return useMemo(
    () =>
      columns
        .filter(
          (definition) => definition.editable !== false && definition.type
        )
        .map((definition) => definition.accessor as string),
    [columns]
  );
};
